/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';

import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';

class ExternalFile extends Backbone.Model {
  static initClass(): void {
    this.prototype.urlRoot = '/1/api/external-files';
  }

  availablePreviewTypes(): Array<EXTERNAL_FILE_TYPE> {
    return this.get('availablePreviewTypes');
  }

  externalFileURL(): string {
    return this.get('url');
  }

  externalFileId(): string {
    return this.get('id');
  }

  previewType(): EXTERNAL_FILE_TYPE | null {
    return this.get('previewType');
  }

  static toName({url}: {url: string}): string | undefined {
    return url.split('/').pop();
  }
}
ExternalFile.initClass();

export default ExternalFile;
